import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { User2Icon } from "@/shared/icons";

type Props = {
  src: string;
  title: string;
  type: string;
  name?: string;
  isBusy?: boolean;
};

export default function FactionTransportCard({ src, title, type, name, isBusy }: Props) {
  const { t } = useTranslation("faction");

  const ownerName = name || "-";
  const background = isBusy
    ? "linear-gradient(305deg, rgba(186, 68, 68, 0.00) 35.7%, rgba(186, 68, 68, 0.06) 72.14%, rgba(186, 68, 68, 0.23) 100%), #181818"
    : "linear-gradient(312deg, rgba(255, 255, 255, 0.00) 45.73%, rgba(255, 255, 255, 0.01) 83.66%, rgba(255, 255, 255, 0.06) 100%), #181818";

  return (
    <div
      className="relative flex flex-col justify-end items-start h-[14.75rem] rounded-2xl p-4"
      style={{ background }}
    >
      <div
        className={clsx(
          "absolute top-1 left-0 w-full h-28 bg-contain bg-no-repeat bg-center",
          isBusy && "opacity-45",
        )}
        style={{ backgroundImage: `url(${src})` }}
      />
      <div>
        <div className="relative flex justify-center items-center w-fit h-6 mb-3 py-1.5 px-3 rounded-md overflow-clip">
          <div
            className={clsx(
              "absolute top-0 left-0 size-full",
              isBusy ? "bg-[#E85C5C]/15" : "bg-[#81C39A]/15",
            )}
            style={{ backdropFilter: "blur(2px)" }}
          />
          <p
            className={clsx(
              "relative z-1 text-10 font-bold uppercase",
              isBusy ? "text-[#E85C5C]" : "text-[#81C39A]",
            )}
          >
            {isBusy ? t("faction.busy") : t("faction.free")}
          </p>
        </div>
        <p className="mb-0.75 text-15 font-bold">{title}</p>
        <p className="mb-4 text-13 font-medium text-white/70">
          {t(`faction.transportTabs.${type}`)}
        </p>
        <div className="flex items-center">
          <User2Icon className="size-4 text-white/50" />
          <p className="ml-2 text-14 font-bold">{ownerName}</p>
        </div>
      </div>
    </div>
  );
}
